import { takeEvery, fork, put, all, call } from "redux-saga/effects"
import toastr from "toastr"
import i18n from "i18n"
import { API } from "api"
import { deactivateCompany } from "./slice"
import { userAccountsList } from "../list/slice"

function* deactivate({ payload: { id, onSuccess } }) {
  try {
    const response = yield call(API.admin.deactivateCompany, id)

    const { data } = response

    yield put(userAccountsList.updateItem({ ...data?.data }))

    yield put(deactivateCompany.deactivateCompleted())

    toastr.success(i18n.t("deactivate.success.message"))

    if (onSuccess) {
      onSuccess()
    }
  } catch (error) {
    const errors = error.response?.data?.errors || {}
    const message = error.response?.data?.message || i18n.t("error")

    yield put(
      deactivateCompany.deactivateRejected({
        errors,
        message,
      })
    )
    toastr.error(message)
  }
}

export function* watchDeactivate() {
  yield takeEvery(deactivateCompany.deactivate, deactivate)
}

function* deactivateSaga() {
  yield all([fork(watchDeactivate)])
}

export default deactivateSaga
